import * as React from 'react';
import {WithStyles, withStyles,} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import { MonthviewStyle } from './monthview.style';
import { IFamilyMember } from '@app-types/websocket/family.types';
import { IEvent } from '@app-types/websocket/event.types';
import { FamilyMemberType } from '@services/family/family.constants';
import { CircleIcon } from '@icons/Circle';
import { CheckmarkRoundSolidIcon } from '@icons/Checkmark-circle-solid';
import { CheckmarkRoundCheckedIcon } from '@icons/Checkmark-circle-line';

const tn: TranslateNew = TranslateNew.getInstance();

const BG_OPACITY = "d6";

interface IProps extends WithStyles<typeof MonthviewStyle> {
  event:IEvent;
  shape:React.CSSProperties; // width, margin and corners from the row layout
  family:IFamilyMember[];
  evenDay:boolean;
  hide?:boolean;
  style?:React.CSSProperties;
  userId:number;
}

interface IState {
  someValue: number;
}

class DayEvent extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
      someValue: 1,
    };

  }

  public componentDidUpdate(prevProps: Readonly<IProps>): void {
    return;
  }

  public componentDidMount() {
    return;
  }

  public render() {
    const {classes, event, family, shape} = this.props;
    let background:string = "#c3c3c3"+BG_OPACITY;
    const childColors:string[] = [];
    const adultColors:string[] = [];
    if (event.tagged && event.tagged.length > 0) {
      for (const tagged of event.tagged) {
        for (const mem of family) {
          if (tagged === mem.id) {
            if (mem.role === FamilyMemberType.CHILD) {
              childColors.push(mem.color);
            } else {
              adultColors.push(mem.color);
            }
          }
        }
      }
    }

    if (childColors.length > 0) {
      background = this.background(childColors);
    } else if (adultColors.length > 0) {
      background = this.background(adultColors);
    }

    let opacity:number = 1;

    if (this.props.hide) {
      opacity = 0;
    }

    let prefix = <span />;
    if (event.checkmark === true) {
      /* Match the chip text — always black on pastel/parent-colored
         background, in both themes. Default icon fill (greyDark1)
         flips to light grey in dark mode and would wash out. */
      const checkmarkStyle:React.CSSProperties = { opacity:'0.8', height: '8px', width: '8px', marginRight: '2px', fill: '#000000' };
      if (event.completedBy === undefined) {
        prefix = <CircleIcon style={checkmarkStyle} />;
      } else {
        prefix = <CheckmarkRoundCheckedIcon style={checkmarkStyle}/>;
      }
    }

    const finalStyle:React.CSSProperties= { ...this.props.style, background, ...shape, opacity };

    if (event.tagged && event.tagged.includes(this.props.userId)) {
      finalStyle.fontWeight = 600;
    }

    return (
      <div className={classes.event} style={finalStyle} >
        {prefix}
        {event.title}
      </div>
    );
  }

  private background(colors:string[]):string {
    if (colors.length === 0) {
      return "#c3c3c3"+BG_OPACITY;
    } else if (colors.length === 1) {
      return colors[0]+BG_OPACITY;
    } else {
      if(this.props.evenDay) {
        colors = colors.reverse();
      }
      return "linear-gradient(45deg, "+colors[0]+BG_OPACITY+" 0%, "+colors[1]+BG_OPACITY+" 100%)";
    }
  }

}

export default withStyles(MonthviewStyle)(DayEvent);



// WEBPACK FOOTER //
// ./src/components/calendar2/monthView/DayEvent.tsx